import { FeatureFlag, FeatureFlagValue, get as getFeatureFlag } from '../FeatureFlagService/FeatureFlagService';

import FreshDeskInAppChatService from './FreshdeskInAppChatService';
import ZendeskInAppChatService from './ZendeskInAppChatService';
import { InAppChatService } from './types';

function resolveBasedOnFeatureFlag(hasFresdeshToZendeskMigrationEnabled?: FeatureFlagValue): InAppChatService {
  return hasFresdeshToZendeskMigrationEnabled ? ZendeskInAppChatService : FreshDeskInAppChatService;
}

function getFeatureFlagValue() {
  return getFeatureFlag(FeatureFlag.EnableFreshdeskToZendeskMigration);
}

const FlagBasedInAppChatService: InAppChatService & {
  initialize: (hasFresdeshToZendeskMigrationEnabled: FeatureFlagValue) => void;
} = {
  initialize: function (hasFresdeshToZendeskMigrationEnabled?: FeatureFlagValue) {
    resolveBasedOnFeatureFlag(hasFresdeshToZendeskMigrationEnabled).initialize();
  },
  open: function () {
    resolveBasedOnFeatureFlag(getFeatureFlagValue()).open();
  },
  show: function () {
    resolveBasedOnFeatureFlag(getFeatureFlagValue()).show();
  },
  hide: function () {
    resolveBasedOnFeatureFlag(getFeatureFlagValue()).hide();
  },
};

export default FlagBasedInAppChatService;
